'use strict';

module.exports = function (ngModule)
{
    // Failed SSL Certificate Validation
    ngModule.controller('sslCertsController', require('./ssl_certs'));
    // DNS Exfiltration (UDP Tunneling)
    ngModule.controller('dnsExfilTunnelsController', require('./dns_exfil_udp_tunnels'));
    // DNS Exfiltration (Subdomains on a Top Level Domain)
    ngModule.controller('dnsExfilSubdomainsController', require('./dns_exfil_subdomains'));
    // DNS Exfiltration (DNS Queries)
    //ngModule.controller('dnsExfilQueriesController', require('./dns_exfil_queries'));
    // Kaminsky DNS Attack (Duplicate DNS Source Ports)
    ngModule.controller('dnsPoisoning', require('./dns_poisoning'));
    // DNS Tunnel (DNScat2)
    ngModule.controller('dnsTunnelDnscat2', require('./dns_tunnel_dnscat2'));
    // DNS Tunnel (Iodine-1)
    ngModule.controller('dnsTunnelIodine1', require('./dns_tunnel_iodine_1'));
    // DNS Tunnel (Iodine-2)
    ngModule.controller('dnsTunnelIodine2', require('./dns_tunnel_iodine_2'));
    // Suspicious Subdomains
    ngModule.controller('suspiciousSubdomains', require('./suspicious_subdomains'));
    // Long Duration Connections
    ngModule.controller('longDurationConns', require('./long_duration_conns'));
    // Large HTTP Responses (More than 1KB)
    ngModule.controller('largeHttpResponses', require('./large_http_responses'));
    // Non-Standard HTTP
    ngModule.controller('nonStandardHttp', require('./non_standard_http'));
    // Services Breakdown
    ngModule.controller('servicesBreakdown', require('./services_breakdown'));
    // User-Agents (HTTP)
    ngModule.controller('userAgents', require('./user_agents'));
    // Top Responder Ports
    ngModule.controller('topResponderPorts', require('./top_responder_ports'));
    // Top Internal Producers
    ngModule.controller('topInternalProducers', require('./top_internal_producers'));
    // Top Referred Hosts
    ngModule.controller('topReferredHosts', require('./top_referred_hosts'));
    // Most Popular Sites
    ngModule.controller('mostPopularSites', require('./most_popular_sites'));
    // HTTP Beacons
    ngModule.controller('httpBeacons', require('./http_beacons'));
    // DNS Beacons
    ngModule.controller('dnsBeacons', require('./dns_beacons'));
};



/** WEBPACK FOOTER **
 ** ./src/pages/controllers/hunting/index.js
 **/